import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const APP_NAME = 'Westport';

const ROUTE_TITLES: Record<string, string> = {
  '/login': 'Login',
  '/register': 'Register',
  '/dashboard': 'Dashboard',
  '/workflows': 'Workflows',
  '/workflow-builder': 'Workflow Builder',
  '/widgets': 'Widgets',
  '/dashboards': 'Dashboards',
  '/dashboard-builder': 'Dashboard Builder',
  '/assignments': 'Assignments',
  '/summary': 'Summary',
  '/join-team': 'Join Team',
  '/team': 'Team',
  '/coverage': 'Coverage',
  '/settings': 'Settings',
  '/profile': 'Profile',
};

export default function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const basePath = '/' + pathname.split('/').filter(Boolean).slice(0, 1).join('/');
    const title = ROUTE_TITLES[pathname] || ROUTE_TITLES[basePath];
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
  }, [pathname]);

  return null;
}
